import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/switch/style";
import _Switch from "vant/es/switch";
import "vant/es/form/style";
import _Form from "vant/es/form";
import "vant/es/field/style";
import _Field from "vant/es/field";
import "vant/es/tabbar/style";
import _Tabbar from "vant/es/tabbar";
import "vant/es/tabbar-item/style";
import _TabbarItem from "vant/es/tabbar-item";
import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "vant/es/overlay/style";
import _Overlay from "vant/es/overlay";
import "vant/es/picker/style";
import _Picker from "vant/es/picker";
import "vant/es/list/style";
import _List from "vant/es/list";
import "vant/es/cell-group/style";
import _CellGroup from "vant/es/cell-group";
import "vant/es/cell/style";
import _Cell from "vant/es/cell";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/nav-bar/style";
import _NavBar from "vant/es/nav-bar";
// 按需全局引入 vant组件
import Vue from 'vue';
Vue.use(_NavBar);
Vue.use(_Button);
Vue.use(_Cell);
Vue.use(_CellGroup);
Vue.use(_List);
Vue.use(_Picker);
Vue.use(_Overlay);
Vue.use(_Popup);
Vue.use(_Tabbar).use(_TabbarItem);
Vue.use(_Field);
Vue.use(_Form);
Vue.use(_Switch);
Vue.use(_Dialog);
Vue.use(_Toast);
Vue.use(_Loading);